<template>
  <div class="devis-page">
    <navbar
      is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
      btn-background="bg-gradient-success"
      :dark-mode="true"
    />
    <div class="min-vh-100 d-flex align-items-center">
      <div class="container-devis">
        <cotation-section />
      </div>
    </div>
    <app-footer />
  </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import CotationSection from '@/components/CotationSection.vue'

export default {
  name: "DevisPage",
  components: {
    Navbar,
    AppFooter,
    CotationSection
  },
  mounted() {
    // Scroll vers le haut en smooth
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}
</script>

<style scoped>
.devis-page {
  background: #E8F1FA;
  min-height: 100vh;
}

.min-vh-100 {
  padding: 60px 0;
}

.container-devis {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Réduction légère de la taille globale */
:deep(.cotation-section) {
  max-width: 100%;
  transform: scale(0.92);
  transform-origin: center;
  margin: 0 auto;
}
</style>
